import React from 'react';

import callApi from '../../utils/callApi';
import { UserContext } from '../../context/index.js';
import { FETCH_AUDITION_LIST } from '../../constants/apiUrls/apiUrls';
import Auditions from '../../components/auditionsComponents/Auditions';
import VideoPlayer from '../../components/videoComponents/VideoPlayer';
import LockedVideo from '../../components/videoComponents/LockedVideo';
import Adds from '../../components/Adds/Adds.js';
import { createBrowserHistory } from 'history';


class AuditionsPage extends React.Component {
  constructor(props) {
    super(props);
    this.params = new URLSearchParams(window.location.search);
    this.page = parseInt(this.params.get('page'), 10) - 1;
    this.history = createBrowserHistory();
    this.state = {
      isLoggedInUser: true,
      showVideo: false,
      showSegmentList: false,
      videoElement: null,
      currentPageNumber: this.page || 0,
      totalNumberOfEntries: null,
      totalNumberOfPages: null,
      isLoading: false,
      entriesPerPage: 12,
      auditions: [],
      sortOrder: '',
    };
  }

  componentDidMount = () => {
    const id = this.getIdFromPath();
    document.title = 'Auditions | Naked News';
    this.fetchAuditionList(id);
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  handleHistoryPush = (page) => {
    this.history.push({
      pathname: window.location.pathname,
      search: `?page=${page}`,
    });
  }

  loadMore = (e) => {
    const pageNum = e.target.value || this.state.currentPageNumber;
    this.handleHistoryPush(pageNum);
    this.setState({ isLoading: true, currentPageNumber: pageNum - 1 }, () => this.fetchAuditionList());
    this.scrollToTop();
  };

  setSortOrder = (value) => {
    this.setState({ sortOrder: value }, () => this.fetchAuditionList());
  };

  getIdFromPath = () => {
    const { location } = this.props;
    const regex = /(-\d{1,})/;
    const found = location.pathname.match(regex);

    return found && found.length ? found[0].replace('-', '') : false;
  };

  appendAuditionString = (title) => {
    if (title.indexOf('Audition') === -1) {
      return `${title}'s Audition`;
    }

    return title;

  };

  fetchAuditionList = (id) => {
    const { currentPageNumber, entriesPerPage, sortOrder } = this.state;
    const url = FETCH_AUDITION_LIST.replace('{page}', currentPageNumber).
      replace('{size}', entriesPerPage);
    callApi(url, 'get', { sortOrder }).
      then((res) => {
        const segments = res.data.segments.map((el) => {
          el.title = this.appendAuditionString(el.title);

          return el;
        });
        if (id) {
          const videoElement = res.data.segments.filter((audition) => audition.auditionId == id);
          const videoEl = { auditionId: id };
          this.setState({
            auditions: segments,
            totalNumberOfEntries: res.data.count,
            totalNumberOfPages: Math.ceil(res.data.count / entriesPerPage),
            isLoading: false,
            videoElement: videoElement[0] || videoEl,
            showVideo: true,
            typeOfListing: 'amature-audition',
          });
        } else {
          this.setState({
            auditions: segments,
            totalNumberOfEntries: res.data.count,
            totalNumberOfPages: Math.ceil(res.data.count / entriesPerPage),
            isLoading: false,
            videoElement: null,
            showVideo: false,
          });
        }

      });
  };

  decideVideoRender = () => {
    const { showVideo, showSegmentList, videoElement } = this.state;
    const { user } = this.props;
    const isSubscribed = user?.user?.activeSubscription;

    if (typeof videoElement === 'undefined' || videoElement === null) {
      return false;
    }

    if (showVideo) {
      if (!isSubscribed) {
        return (
          <LockedVideo typeOfListing={'audition'} videoElement={videoElement} />);
      }

      return (
        <VideoPlayer
          key={videoElement.id}
          isProgram={showSegmentList}
          typeOfListing={'audition'}
          user={user}
          videoElement={videoElement}
        />
      );
    }

    return false;
  };

  render() {
    const { auditions, isLoading, sortOrder, currentPageNumber, totalNumberOfPages } = this.state;

    return (
      <div id="application">
        {this.decideVideoRender()}
        <Auditions
          auditions={auditions}
          isLoading={isLoading}
          loadMore={this.loadMore}
          setSortOrder={this.setSortOrder}
          sortOrder={sortOrder}
          currentPageNumber={currentPageNumber}
          totalNumberOfPages={totalNumberOfPages}
        />
        <Adds isAnchorPage={false} />
      </div>
    );
  }
}

AuditionsPage.contextType = UserContext;

export default AuditionsPage;
